import Enumerable from "linq";
import { IRunTicketModel } from "../../services/run-tickets-data-service/Models";

export type UseRunTicketsReturnType = {
    runTickets: IRunTicketModel[];
    tanks: IRunTicketModel.Tank[];
    totalCount: number;
    filteredCount: number;
};

export type UseRunTicketTanksReturnType = Array<IRunTicketModel.Tank>;

export type UseRunTicketsOptionsType = {
    tankIDs?: Array<number>;
};

export type MutationContextType = {
    previousRunTickets: Array<IRunTicketModel> | undefined;
};

export function selectRunTickets(runTickets: Array<IRunTicketModel>, options?: UseRunTicketsOptionsType): UseRunTicketsReturnType {

    const filteredRunTickets = (
        options?.tankIDs?.length
            ? Enumerable
                .from(runTickets)
                .join(
                    options?.tankIDs ?? [],
                    o => o.tank.id,
                    i => i,
                    (o, i) => o
                )
            : Enumerable
                .from(runTickets)
    )
        .orderByDescending(rt => new Date(rt.createdDateTime).valueOf)
        .toArray();

    const tanks = Enumerable
        .from(runTickets)
        .distinct(rt => rt.tank.id)
        .select(rt => rt.tank)
        .toArray();

    return {
        runTickets: filteredRunTickets,
        tanks: tanks,
        totalCount: runTickets.length ?? 0,
        filteredCount: filteredRunTickets.length ?? 0
    };
}